import { useMemo } from 'react';
import { getPayCorrectionAdjustedSalaryByEmployeeId } from 'apps/sigma2-ui/src/pay-correction/libs/getPayCorrectionAdjustedSalaryByEmployeeId';
import { PayCorrectionEmployeeItem } from 'apps/sigma2-ui/src/pay-correction/components/PayCorrectionTable';
import { PayCorrectionAdjustedEmployeeSalaries } from 'libs/end-to-end/src/pay-correction/types/PayCorrectionAdjustedEmployeeSalaries';

export const usePayCorrectionBudgetNeeded = ({
  listItems,
  adjustedSalaries,
}: {
  listItems: PayCorrectionEmployeeItem[];
  adjustedSalaries: PayCorrectionAdjustedEmployeeSalaries;
}) => {
  return useMemo(() => {
    return listItems.reduce((acc, curr) => {
      const currAdjustedSalary = getPayCorrectionAdjustedSalaryByEmployeeId({
        adjustedSalaries,
        employeeid: curr.employeeid,
        recommendedSalary: curr.recommended_salary,
      });

      return acc + (currAdjustedSalary - curr.salary);
    }, 0);
  }, [adjustedSalaries, listItems]);
};
